import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var supportiveCoverageIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.98 19.944c5.264-4.25 12.815-4.246 18.074.01a.99.99 0 0 1 .09 1.468l-.31.327c-4.946-4.69-12.738-4.69-17.684 0l-.31-.327a.987.987 0 0 1 .14-1.478ZM.577 17.459c6.435-5.947 16.411-5.947 22.846 0a.988.988 0 0 1 0 1.468l-.3.327A15.315 15.315 0 0 0 12.02 14.5c-4.203 0-8.22 1.72-11.102 4.754l-.34-.327-.084-.085a.987.987 0 0 1 .083-1.383ZM23.122 4.745l.3.327a.988.988 0 0 1 0 1.468c-6.434 5.947-16.41 5.947-22.845 0a.988.988 0 0 1-.083-1.383l.083-.085.34-.327A15.315 15.315 0 0 0 12.02 9.499c4.203 0 8.22-1.72 11.102-4.754ZM20.834 2.25l.31.327a.987.987 0 0 1-.09 1.468c-5.259 4.256-12.81 4.26-18.074.01a.99.99 0 0 1-.14-1.478l.31-.327c4.946 4.69 12.738 4.69 17.684 0Z",
  fill: "currentColor"
}));

export { supportiveCoverageIcon as default };
//# sourceMappingURL=supportiveCoverageIcon.js.map
